import React from 'react';

import { AppstoreOutlined } from '@ant-design/icons';

import { UseAsyncMultiSelectProps } from 'components/AsyncSelect/types';

import { AsyncMultiSelect } from '../../AsyncSelect/AsyncMultiSelect';

export type ProductGroupMultiSelectProps = {
  mode?: 'multiple' | 'single';
  selectProps: UseAsyncMultiSelectProps;
  selectedValues: string[];
  onSelectedValuesChange: (newItemGroupIds: string[]) => void;
  onOpenChange?: (isOpen: boolean) => void;
};

export function ProductGroupMultiSelect({
  mode = 'multiple',
  selectedValues,
  onSelectedValuesChange,
  selectProps,
  onOpenChange,
}: ProductGroupMultiSelectProps) {
  return (
    <AsyncMultiSelect
      mode={mode}
      label="Product Group"
      icon={<AppstoreOutlined />}
      selectedValues={selectedValues}
      onSelectedValuesChange={onSelectedValuesChange}
      queryPlaceholder="Search product groups"
      selectProps={selectProps}
      showClearButtonOnSingleMode
      onOpenChange={onOpenChange}
    />
  );
}
